/***************************************************************************************
 * FileName      : DataValueType.ts
 * Description   : 데이터 타입 상수 및 타입 (JSON dataType 필드)
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.10
 * Modified Date :
 * Reference     : packages/scjeil-smart_ict_lab-app/assets/json/equipment/*.json → controls[]/sensors[].dataType
 ***************************************************************************************/

// 2026.02.10 : 박은정 : 데이터 타입 알려진 값 (확장 가능성 중간 → const + type)
// → 새 데이터 타입(예: int, string) 추가 시 여기에 값만 추가
export const DataValueTypes = {
  Float: 'float',
  Bool: 'bool',
} as const;

export type DataValueType = (typeof DataValueTypes)[keyof typeof DataValueTypes] | string;

